import { render, staticRenderFns } from "./company-send-email.vue?vue&type=template&id=40b91e2e&"
import script from "./company-send-email.vue?vue&type=script&lang=js&"
export * from "./company-send-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports